module.exports = __webpack_public_path__ + "static/img/logo3gtapp.0ecbc09d.png";